// 5 秒内连续点击某个元素 8 次触发事件
export default {
  bind(el, binding) {
    let clickCount = 0
    let lastClickTime = 0
    const handler = () => {
      const now = Date.now()
      if (now - lastClickTime < 5000) {
        clickCount++
        if (clickCount >= 8) {
          // 如果在5秒内点击次数达到8次，则触发事件
          binding.value()
          // 重置点击次数
          clickCount = 0
        }
      } else {
        // 如果超过了5秒，则重置点击次数和时间
        clickCount = 1
      }
      lastClickTime = now
    }
    el.addEventListener('click', handler)
  }
}
